module.exports = __webpack_public_path__ + "static/img/img404.83d723fc.png";